import React, { Fragment, useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { updateBrokerConnectData } from '@actions/brokerConnect/brokerConnectActionCreators';
import Switch from 'react-switch';

import { configs } from '@constants/configs/configs';
import { SLIDER_ACTIVITY_TYPES } from '@constants/common/statusTypes';

const Slider = props => {

    const { available, actions, status } = props;
    const { endpoints } = configs;
    const [ isAvailable, setAvailable ] = useState(available);

    const handleChange = () => {
        setAvailable(!isAvailable);

        actions.updateBrokerConnectData(endpoints.BROKERCONNECT_AVAILABILITY, { ...props, available: !isAvailable });
    };

    useEffect(() => {
        setAvailable(available);
    }, [ available ]);

    const isDisabled = status === 'INACTIVE' ? true : false;

    return (
        <Fragment>
            <label>
                <Switch
                    onChange={handleChange}
                    checked={isAvailable}
                    width={65}
                    disabled={isDisabled}
                    offColor='#b5b5b5'
                    onColor='#007fae'
                    uncheckedIcon={
                        <div className="availibility__slider__item--off">{ SLIDER_ACTIVITY_TYPES.OFF }</div>
                    }
                    checkedIcon={
                        <div className="availibility__slider__item--on">{ SLIDER_ACTIVITY_TYPES.ON }</div>
                    }
                />
            </label>
        </Fragment>
    );
};

const matchDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        updateBrokerConnectData
    }, dispatch)
});

export default connect(null, matchDispatchToProps)(Slider);